import { tokens } from '@datacamp/waffles/tokens';
export const LIGHT_THEME_NAME = 'datacamp-2020-light';
export const DARK_THEME_NAME = 'datacamp-2020-dark';
export const lightTheme = {
  base: 'vs',
  colors: {
    'editor.background': tokens.colors.white,
    'editorLineNumber.foreground': tokens.colors.navyLight
  },
  inherit: true,
  rules: [{
    foreground: tokens.colors.greenDarkText,
    token: 'comment'
  }, {
    foreground: tokens.colors.blueDarkText,
    token: 'keyword'
  }, {
    foreground: tokens.colors.blueDarkText,
    token: 'operator.sql'
  }, {
    foreground: tokens.colors.navy,
    token: 'identifier'
  }, {
    foreground: tokens.colors.navy,
    token: 'type.identifier.shell'
  }, {
    foreground: tokens.colors.navy,
    token: 'attribute.name.shell'
  }, {
    foreground: tokens.colors.pinkDarkText,
    token: 'number'
  }, {
    foreground: tokens.colors.pinkDarkText,
    token: 'string'
  }, {
    foreground: tokens.colors.pinkDarkText,
    token: 'string.html'
  }, {
    foreground: tokens.colors.pinkDarkText,
    token: 'string.sql'
  }, {
    foreground: tokens.colors.pinkDarkText,
    token: 'string.yaml'
  }, {
    foreground: tokens.colors.orangeDarkText,
    token: 'predefined.sql'
  }]
};
export const darkTheme = {
  base: 'vs-dark',
  colors: {
    'editor.background': tokens.colors.navy,
    'editorLineNumber.foreground': tokens.colors.greyLight
  },
  inherit: true,
  rules: [{
    foreground: tokens.colors.greenDark,
    token: 'comment'
  }, {
    foreground: tokens.colors.blueDark,
    token: 'keyword'
  }, {
    foreground: tokens.colors.blueDark,
    token: 'operator.sql'
  }, {
    foreground: tokens.colors.white,
    token: 'identifier'
  }, {
    foreground: tokens.colors.white,
    token: 'type.identifier.shell'
  }, {
    foreground: tokens.colors.white,
    token: 'attribute.name.shell'
  }, {
    foreground: tokens.colors.pinkDark,
    token: 'number'
  }, {
    foreground: tokens.colors.pinkDark,
    token: 'string'
  }, {
    foreground: tokens.colors.pinkDark,
    token: 'string.html'
  }, {
    foreground: tokens.colors.pinkDark,
    token: 'string.sql'
  }, {
    foreground: tokens.colors.pinkDark,
    token: 'string.yaml'
  }, {
    foreground: tokens.colors.orangeDark,
    token: 'predefined.sql'
  }]
};